import axios from 'axios';

/**
 * @typedef {object} Path
 * @property {number}   id
 * @property {string}   name
 * @property {number[]} courses
 */

export default {
  /**
   * @async
   * @returns {Path[]}
   */
  getPaths(includeFocuses) {
    var options = {
      method: 'GET',
      baseURL: window.apiUrl,
      url: '/paths?include_focuses='+includeFocuses,
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    };
    return axios.request(options).then(response => {
      if (!response.data.success) {
        throw new Error(response.data.error);
      }
      return response.data.paths;
    });
  },

  /**
   * @async
   * @param {number} id
   * @returns {Path}
   */
  getPath(id) {
    // TODO: use server-side route like /paths/:id instead of just filtering
    // through all paths
    return module.exports.default.getPaths().then(paths => {
      const path = paths.find(p => p.id == id);
      if (!path) {
        throw new Error('path not found');
      }
      return path;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/paths/index.js